import BackendAPIService from './BackendAPIService'
import type { ServiceParameters } from './commonTypes'
import type { ICancellationReasonResponse } from './models/cancellation'

const config = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}

const API_VERSION = 'v1'

class CancellationService extends BackendAPIService {
  constructor(props: ServiceParameters) {
    super(props)

    this.apiVersion = API_VERSION
  }

  async getSingleItemCancellationReasons() {
    const { data } = await this.get<ICancellationReasonResponse>(
      `cancellation/${this.apiVersion}/${this.tenantPath}/cancel/reasons`,
      config
    )

    return data
  }
}

export default CancellationService
